module.exports = __webpack_public_path__ + "img/Enzymotherapy22.73358c15.jpg";